/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import $ from 'jquery';
import {
    forEach,
    includes,
    findIndex,
    filter,
    startsWith,
    get,
    assignIn,
    map,
    cloneDeep,
    find,
    merge,
} from 'lodash';
import {
    REQUEST_TYPE_HISTORY,
    REQUEST_TYPE_FIELD_LIST,
    REQUEST_TYPE_LOGIC,
    REQUEST_TYPE_ASSIGNEE,
    REQUEST_TYPE_KEYWORDS,
    REQUEST_TYPE_AUTOCOMPLETE,
    REQUEST_TYPE_DATE,
    REQUEST_TYPE_DATE_Y,
    REQUEST_TYPE_DATE_YM,
    REQUEST_TYPE_RANGE,
    REQUEST_TYPE_RANGE_SHORT,
    REQUEST_TYPE_GNAME,
    REQUEST_TYPE_WORKSPACE,
    REQUEST_TYPE_CUSTOM_FIELD,
    REQUEST_TYPES,

    TOKEN_TYPE_LOGIC,
    TOKEN_TYPE_OPERATOR,
    TOKEN_TYPE_PLACESYMBOL,
    TOKEN_TYPE_SPACE,
    TOKEN_TYPE_USER,
    TOKEN_TYPE_WORKSPACE,
    TOKEN_TYPE_QUERYSYMBOL,
    EXPRESSION_TYPE_FIELD,
    EXPRESSION_TYPE_RANGE,
    EXPRESSION_TYPE_TOKEN,
    SECTION_TYPE_ANCS,
    SECTION_TYPE_FIELD,
    SECTION_TYPE_HISTORY,
    SECTION_TYPE_KEYWORDS,
    SUPPORT_ANCS_FIELDS,
    SECTION_TYPE_LOGIC,
    SECTION_TYPE_SAMPLE,
    SECTION_TYPE_QUERY,
    EXPRESSION_TYPE_OPERATOR,
    SECTION_TYPE_AUTOCOMPLETE,
    SECTION_TYPE_WORKSPACE,
    OPERATOR_COLON,
    TOKEN_TYPE_TREE,
    TOKEN_TYPE_SPECIAL_SYMBOL,
} from '../../constants';
import {
    SUPPORT_KEYWORDS_FIELDS,
    DEFAULT_SYNTAX_VALUES,
    DATE_TYPE_FIELDS,
    DATE_Y_TYPE_FIELDS,
    DATE_YM_TYPE_FIELDS,
    RANGE_TYPE_FIELDS,
    RANGE_TYPE_FIELDS_SHORT,
    RANGE_SAMPLE,
    RANGE_SAMPLE_SHORT,
    WORKSPACE_FIELDS,
    DATE_SAMPLE,
    DATE_Y_SAMPLE,
    DATE_YM_SAMPLE,
    SYNTAX_VALUES,
} from '../config';
import { getDefaultSuggestions, findFieldSuggestionsByStem, getLogicSuggestions } from '../utils';

export default class Suggestion {
    constructor(options, isRDVersion = false) {
        const defaultOption = {
            debugger: true,
            suggestionTypeList: [
                REQUEST_TYPE_AUTOCOMPLETE,
                REQUEST_TYPE_ASSIGNEE,
                REQUEST_TYPE_FIELD_LIST,
                REQUEST_TYPE_HISTORY,
                REQUEST_TYPE_KEYWORDS,
                REQUEST_TYPE_LOGIC,
                REQUEST_TYPE_DATE,
                REQUEST_TYPE_DATE_Y,
                REQUEST_TYPE_DATE_YM,
                REQUEST_TYPE_RANGE,
                REQUEST_TYPE_RANGE_SHORT,
                REQUEST_TYPE_GNAME,
                REQUEST_TYPE_WORKSPACE,
                REQUEST_TYPE_CUSTOM_FIELD,
            ],
        };
        this.options = assignIn(defaultOption, options);
        this.cursorRange = {};
        this.expressionTree = {};
        /** cursorWordData包含对象
     *  cursorToken: 当前光标所在token,
     *  cursorExp: 当前光标所在表达式,
     *  cursorFieldExp: 当前光标所在字段表达式,
     *  stemStartToken: stem为词组时，开始的token
    * */
        this.cursorWordData = {};
        this.$el = '';
        this.isRDVersion = isRDVersion;
    }

    initSuggestion(expressionTree, range, elem) {
        this.$el = $(elem);
        this.expressionTree = expressionTree;
        this.cursorRange = range || {};
    }

    // 获取替换推荐词之后的 queryText
    getQueryTextWidthSuggeston(dropData) {
        let text = dropData.data.value;
        const { section } = dropData;
        if (section !== SECTION_TYPE_FIELD && section !== SECTION_TYPE_LOGIC && section !== SECTION_TYPE_HISTORY) {
            // eslint-disable-next-line no-useless-escape
            if (section === SECTION_TYPE_WORKSPACE) {
                text = `|${text}|`;
            } else if (section !== SECTION_TYPE_QUERY) {
                // eslint-disable-next-line no-useless-escape
                text = `\"${text}\"`;
            }

            if (section === SECTION_TYPE_KEYWORDS) {
                text = `OR ${text}`;
            }
            if (section === SECTION_TYPE_ANCS && get(this.cursorWordData, 'cursorFieldExp.expressionType') !== EXPRESSION_TYPE_FIELD) {
                text = `ANCS:(${text})`;
            }
            // 表达式中包含左括号则自动补全右括号
            if (get(this.cursorWordData, 'cursorExp.expressionType') === EXPRESSION_TYPE_OPERATOR) {
                const children = get(this.cursorWordData, 'cursorExp.children');
                if (get(children, '[0].data.value') === '(' && get(children, `[${children.length - 1}].data.value`) !== ')') {
                    text += ')';
                }
            }
        }
        const tokenData = get(this.cursorWordData, 'cursorToken.data', {});
        const stemStartToken = get(this.cursorWordData, 'stemStartToken.data', {});
        let start = tokenData.start || 0;
        if ((section === SECTION_TYPE_AUTOCOMPLETE || section === SECTION_TYPE_ANCS) && stemStartToken.start) {
            start = stemStartToken.start;
        }
        let rangeStart = start + text.length;
        let isRangeLast = true;
        // 如果光标不是在最后则不做处理
        if (tokenData.end > this.cursorRange.end) {
            isRangeLast = false;
        }
        if (tokenData.type === TOKEN_TYPE_SPACE || tokenData.type === TOKEN_TYPE_OPERATOR) {
            text = tokenData.value + text;
            rangeStart = start + text.length;
            if (section === SECTION_TYPE_FIELD) {
                rangeStart--;
            }
        } else if (section === SECTION_TYPE_FIELD) {
            const rangePos = text.indexOf(' TO ');
            if (rangePos > 0) {
                rangeStart = start + rangePos;
            } else {
                rangeStart--;
            }
        }
        let queryText = this.getQueryText(text, section);
        if (section === SECTION_TYPE_HISTORY) {
            queryText = dropData.data.value;
            rangeStart = queryText.length;
            isRangeLast = true;
        }
        const range = {
            start: rangeStart,
            end: rangeStart,
        };
        return {
            queryText,
            range,
            isRangeLast,
        };
    }

    /**
   * 根据光标位置获取推荐词
   * 该方法的返回会通过事件: EVENT_UPDATE_QUERY_DATA 传递到组件外部，
   * 再混合服务端返回的推荐项（根据 requestTypeList 获取) 通过 props: suggestionList 传入
   * 组件.
   *
   * 主要逻辑整理
   * 1. 如果存在cursorFieldExp说明当前光标在字段表达式中则推荐 KEYWORDS, ANCS, logic, history{
   * }
   * 2. 根据cursorExp的中前面token进行推荐
   * a. 如果前一个token为 logic 则推荐field, history, ANCS
   * b. 如果前一个token为user 则推荐logic, history, ANCS
   * c. 如果前面没有token 则推荐 field, history, ANCS
   * 3. 如果cursorToken不为空格，需要添加推荐 keyWords
   *
   * @param {obj} range 光标位置
   * @returns
   */
    getSuggestionByCursor(range) {
        this.cursorRange = range || {};
        this.cursorWordData = {};
        let suggestion = []; // 内部 suggestion 数据
        let stem = '';
        let requestTypeList = [];
        const specialTypeList = []; // 特殊类型的type
        // 如果输入为空(或空字符)
        if (!get(this.expressionTree, 'value', '').trim()) {
            suggestion = [getDefaultSuggestions(this.isRDVersion)];
            return {
                stem,
                suggestion,
                requestTypeList,
            };
        }

        this.prepareCursorWordData(this.expressionTree, range);

        if (!this.cursorWordData.cursorToken) {
            return;
        }

        const data = this.getSuggestionFnDataByCursor();
        const {
            requestTypes,
            cursorFieldData,
        } = data;
        stem = data.stem;

        // FIXME: 如果 stem 存在且需要 field 类型的 suggestions
        if (includes(requestTypes, REQUEST_TYPE_FIELD_LIST)) {
            // eslint-disable-next-line no-mixed-operators
            const qStem = stem && stem.trim().toUpperCase() || '';
            const suggestions = findFieldSuggestionsByStem(qStem, this.isRDVersion);
            if (suggestions) {
                suggestion.push(suggestions);
            }
        }
        // FIXME: 如果 stem 存在且需要 logic 类型的 suggestions
        if (includes(requestTypes, REQUEST_TYPE_LOGIC)) {
            const suggestions = getLogicSuggestions();
            if (suggestions) {
                suggestion.push(suggestions);
            }
        }
        // SYNTAX_VALUES 默认值
        if (cursorFieldData) {
            if (DEFAULT_SYNTAX_VALUES[cursorFieldData.fieldName]) {
                cursorFieldData.default = DEFAULT_SYNTAX_VALUES[cursorFieldData.fieldName];
            }
            const suggestions = this.getSyntaxSuggestionsBySyntax(stem, cursorFieldData);
            if (suggestions) {
                suggestion.push(suggestions);
            }
        }
        const fieldName = get(this.cursorWordData, 'cursorFieldExp.children[0].data.value', '').toLocaleUpperCase();
        // range类型提示sample suggestion.REQUEST_TYPE_RANGE_SHORT是REQUEST_TYPE_RANGE的子类。优先判断，另外子类和父类只能取其一
        if (includes(requestTypes, REQUEST_TYPE_RANGE)) {
            let content;
            if (includes(requestTypes, REQUEST_TYPE_RANGE_SHORT)) {
                content = map(RANGE_SAMPLE_SHORT, (item) => {
                    const itemTemp = cloneDeep(item);
                    itemTemp.name = `${fieldName}:${itemTemp.name}`;
                    return itemTemp;
                });
            } else {
                content = map(RANGE_SAMPLE, (item) => {
                    const itemTemp = cloneDeep(item);
                    itemTemp.name = `${fieldName}:${itemTemp.name}`;
                    return itemTemp;
                });
            }
            const suggestions = {
                section: SECTION_TYPE_SAMPLE,
                content,
            };
            if (suggestions) {
                suggestion.push(suggestions);
            }
        }
        // data类型提示sample suggestion
        if (includes(requestTypes, REQUEST_TYPE_DATE)) {
            let sample = DATE_SAMPLE;
            if (includes(requestTypes, REQUEST_TYPE_DATE_Y)) {
                sample = DATE_Y_SAMPLE;
            } else if (includes(requestTypes, REQUEST_TYPE_DATE_YM)) {
                sample = DATE_YM_SAMPLE;
            }
            const content = map(sample, (item) => {
                const itemTemp = cloneDeep(item);
                itemTemp.name = `${fieldName}:${itemTemp.name}`;
                return itemTemp;
            });
            const suggestions = {
                section: SECTION_TYPE_SAMPLE,
                content,
            };
            if (suggestions) {
                suggestion.push(suggestions);
            }
        }

        // ws类型字段
        if (includes(requestTypes, REQUEST_TYPE_WORKSPACE)) {
            specialTypeList.push(REQUEST_TYPE_WORKSPACE);
        }
        // 自定义字段类型
        if (includes(requestTypes, REQUEST_TYPE_CUSTOM_FIELD)) {
            specialTypeList.push(REQUEST_TYPE_CUSTOM_FIELD);
        }

        /**
     * 只有REQUEST_TYPES才需要从接口中获取数据
     */
        requestTypeList = filter(requestTypes, (item) => includes(REQUEST_TYPES, item));

        return {
            suggestion,
            stem,
            requestTypeList,
            fieldName,
            specialTypeList,
        };
    }

    prepareCursorWordData(expressionTree, pos) {
        let isTokenActive = false;
        if (expressionTree && expressionTree.children && pos) {
            forEach(expressionTree.children, (item) => {
                if (item.expressionType === EXPRESSION_TYPE_TOKEN) {
                    if (item.data.start < pos.start && item.data.end >= pos.end) {
                        this.cursorWordData.cursorToken = item;
                        isTokenActive = true;
                    }
                } else if (item.offset.start < pos.start && item.offset.end >= pos.end) {
                    this.prepareCursorWordData(item, pos);
                }
            });
        }
        if (isTokenActive) {
            this.cursorWordData.cursorExp = expressionTree; // "operator"
        }
        if (this.cursorWordData.cursorExp && !this.cursorWordData.cursorFieldExp && expressionTree && expressionTree.expressionType === EXPRESSION_TYPE_FIELD) {
            this.cursorWordData.cursorFieldExp = expressionTree;
        }
    }

    getSuggestionFnDataByCursor() {
        const {
            cursorToken,
            cursorExp,
            cursorFieldExp,
        } = this.cursorWordData;
        const suggestionFnData = {
            typeList: [],
        };
        const currentIndex = findIndex(cursorExp.children, cursorToken);
        const prevExpType = get(cursorExp.children[currentIndex - 1], 'expressionType');
        const curExpType = get(cursorExp, 'expressionType');
        const prevType = get(cursorExp.children[currentIndex - 1], 'data.type');
        const curType = get(cursorToken, 'data.type');
        const nextType = get(cursorExp.children[currentIndex + 1], 'data.type');
        let stem = '';
        if (curType === TOKEN_TYPE_USER || curType === TOKEN_TYPE_SPACE || curType === TOKEN_TYPE_WORKSPACE) {
            stem = this.getStem();
        }
        suggestionFnData.stem = stem;
        if (cursorFieldExp) {
            const fieldName = get(cursorFieldExp, 'children[0].data.value').toLocaleUpperCase();
            if (includes(DATE_TYPE_FIELDS, fieldName) && cursorToken.data.value === OPERATOR_COLON) {
                suggestionFnData.typeList.push(REQUEST_TYPE_DATE);
            }
            if (includes(DATE_Y_TYPE_FIELDS, fieldName) && cursorToken.data.value === OPERATOR_COLON) {
                suggestionFnData.typeList.push(REQUEST_TYPE_DATE_Y);
            }
            if (includes(DATE_YM_TYPE_FIELDS, fieldName) && cursorToken.data.value === OPERATOR_COLON) {
                suggestionFnData.typeList.push(REQUEST_TYPE_DATE_YM);
            }
            if (includes(RANGE_TYPE_FIELDS, fieldName) && cursorToken.data.value === OPERATOR_COLON) {
                suggestionFnData.typeList.push(REQUEST_TYPE_RANGE);
            }
            if (includes(RANGE_TYPE_FIELDS_SHORT, fieldName) && cursorToken.data.value === OPERATOR_COLON) {
                suggestionFnData.typeList.push(REQUEST_TYPE_RANGE_SHORT);
            }
            if (stem && stem.trim()) {
                if (includes(SUPPORT_ANCS_FIELDS, fieldName) && curType !== TOKEN_TYPE_SPACE && prevType !== TOKEN_TYPE_TREE) {
                    suggestionFnData.typeList.push(REQUEST_TYPE_ASSIGNEE);
                }
                if (includes(SUPPORT_KEYWORDS_FIELDS, fieldName)) {
                    if (/\s$/.test(stem)) {
                        suggestionFnData.typeList.push(REQUEST_TYPE_KEYWORDS);
                    } else {
                        suggestionFnData.typeList.push(REQUEST_TYPE_AUTOCOMPLETE);
                    }
                }
            }
            // 光标位于括号中时
            if (cursorExp.expressionType === EXPRESSION_TYPE_OPERATOR
            && (cursorExp.offset.start < this.cursorRange.start && this.cursorRange.end < cursorExp.offset.end)
            && !/["']$/.test(cursorToken.data.value)) {
                suggestionFnData.cursorFieldData = {
                    fieldName,
                };

                if (includes(WORKSPACE_FIELDS, fieldName)) {
                    suggestionFnData.typeList.push(REQUEST_TYPE_WORKSPACE);
                }

                if (startsWith(fieldName, 'CCF')) {
                    suggestionFnData.typeList.push(REQUEST_TYPE_CUSTOM_FIELD);
                }
            }
        } else if ((cursorToken.data.type === TOKEN_TYPE_USER || cursorToken.data.type === TOKEN_TYPE_SPACE)) {
            if (prevType !== TOKEN_TYPE_TREE && stem && stem.trim()) {
                if (curType !== TOKEN_TYPE_SPACE) {
                    suggestionFnData.typeList.push(REQUEST_TYPE_ASSIGNEE);
                    suggestionFnData.typeList.push(REQUEST_TYPE_FIELD_LIST);
                }
                if (/\s$/.test(stem)) {
                    suggestionFnData.typeList.push(REQUEST_TYPE_KEYWORDS);
                } else {
                    suggestionFnData.typeList.push(REQUEST_TYPE_AUTOCOMPLETE);
                }
            } else if (prevType === TOKEN_TYPE_LOGIC) {
                suggestionFnData.typeList.push(REQUEST_TYPE_FIELD_LIST);
            }
        }

        const fieldName = get(cursorFieldExp, 'children[0].data.value', '').toLocaleUpperCase();
        // 逻辑词的推荐列表
        if (currentIndex > 0
          && curExpType !== EXPRESSION_TYPE_RANGE
          && cursorExp.children.length > 1
          && curType === TOKEN_TYPE_SPACE
          && (
              prevExpType !== EXPRESSION_TYPE_TOKEN
            || prevType === TOKEN_TYPE_USER
            || prevType === TOKEN_TYPE_PLACESYMBOL
            || prevType === TOKEN_TYPE_QUERYSYMBOL
            || prevType === TOKEN_TYPE_WORKSPACE
            || (startsWith(fieldName, 'CCF') && prevType === TOKEN_TYPE_SPECIAL_SYMBOL)
          )
          && nextType !== TOKEN_TYPE_LOGIC) {
            suggestionFnData.typeList.push(REQUEST_TYPE_LOGIC);
            if (!includes(suggestionFnData.typeList, REQUEST_TYPE_KEYWORDS)) {
                suggestionFnData.typeList = [REQUEST_TYPE_LOGIC];
                suggestionFnData.cursorFieldData = {};
            }
        }
        //  截词以引号结尾不提示推荐词
        if (/["']$/.test(cursorToken.data.value)) {
            suggestionFnData.typeList = [];
            return suggestionFnData;
        }
        suggestionFnData.typeList = filter(suggestionFnData.typeList, (item) => includes(this.options.suggestionTypeList, item));
        suggestionFnData.requestTypes = suggestionFnData.typeList;
        return suggestionFnData;
    }

    previewSuggestion(data) {
        const tokenData = get(this.cursorWordData, 'cursorToken.data');
        if (!this.$el) return;
        if (tokenData && get(data, 'data.value') && data.section !== SECTION_TYPE_HISTORY) {
            let start = 0;
            const tStr = tokenData.value.trim();
            const dStr = data.data.value;
            if (tokenData.type === TOKEN_TYPE_USER) {
                start = tStr.length;
            }
            if (start > 0 && !startsWith(dStr.toLocaleUpperCase(), tStr.toLocaleUpperCase())) {
                start = -1;
            }
            if (start > -1) {
                const previewText = dStr.substring(start);
                this.$el.find(`.ed_tk_${this.cursorWordData.cursorToken.data.id}`).addClass('ed_tk_preview').attr('preview-text', previewText);
            } else {
                this.$el.find('.ed_tk_preview').removeAttr('preview-text').removeClass('ed_tk_preview');
            }
        } else {
            this.$el.find('.ed_tk_preview').removeAttr('preview-text').removeClass('ed_tk_preview');
        }
    }

    getQueryText(text, section) {
        const { cursorWordData, expressionTree } = this;
        let queryText = text;
        const cursorToken = get(cursorWordData, 'cursorToken.data');
        const stemStartToken = get(cursorWordData, 'stemStartToken.data');
        if (cursorToken && expressionTree) {
            // eslint-disable-next-line prefer-const
            let { start, end } = cursorToken;
            if (stemStartToken && (section !== SECTION_TYPE_LOGIC && section !== SECTION_TYPE_KEYWORDS && section !== SECTION_TYPE_QUERY)) {
                start = stemStartToken.start;
            }
            queryText = expressionTree.value;
            let endText = queryText.substring(end);
            // eslint-disable-next-line no-useless-escape
            endText = /^[\s\]\)]/.test(endText) ? endText : ` ${endText}`;
            queryText = `${queryText.substring(0, start)}${text}${endText}`;
        }
        return queryText;
    }

    getStem() {
        const {
            cursorToken,
            cursorExp,
        } = this.cursorWordData;
        let stem = '';
        const { data } = cursorToken;
        stem = data.value.substring(0, this.cursorRange.end - data.start);
        for (let i = cursorExp.children.length; i > 0; i--) {
            const item = cursorExp.children[i - 1];
            const end = item.expressionType === EXPRESSION_TYPE_TOKEN ? item.data.end : item.offset.end;
            if (end <= cursorToken.data.start) {
                if (item.expressionType === EXPRESSION_TYPE_TOKEN && (item.data.type === TOKEN_TYPE_USER || item.data.type === TOKEN_TYPE_SPACE)) {
                    stem = item.data.value + stem;
                    if (item.data.type === TOKEN_TYPE_USER) {
                        this.cursorWordData.stemStartToken = item;
                    }
                } else {
                    break;
                }
            }
        }
        stem = stem.replace(/^\s+/, '');
        return stem;
    }

    getSyntaxSuggestionsBySyntax(stem, cursorFieldData) {
        const syntax = cursorFieldData.fieldName;
        const defaultSyntax = cursorFieldData.default;
        if (!syntax) return;
        const syntaxValues = merge({}, SYNTAX_VALUES, this.options.syntaxValues);
        let content = get(syntaxValues, syntax, []);
        if (stem) {
            content = filter(content, ({
                value,
            }) => startsWith(value.toLocaleUpperCase(), stem.toLocaleUpperCase()));
        } else if (defaultSyntax) {
            const defaultContent = [];
            forEach(defaultSyntax, (item) => {
                const itemContent = find(content, (subItem) => subItem.value === item);
                defaultContent.push(itemContent);
            });
            content = defaultContent;
        }
        if (content.length === 0) return;
        return {
            section: syntax,
            content,
        };
    }

    getCursorWordData(range) {
        this.prepareCursorWordData(this.expressionTree, range);
        return this.cursorWordData;
    }
}
